import { css } from '@emotion/css'
import { colors, borderRadius, spacing, fontSize, fontWeight, textStyles, shorthandHelper } from '@offerzen/pinata-shame'

const styles = {
  intro: css({
    ...textStyles,
    marginBottom: spacing.medium,
  }),

  input: css({
    marginBottom: spacing.default,

    '> div': {
      width: '100%',
    },

    // counteract Rails styles
    select: {
      height: '100%',
    },

    // counteract Rails styles
    input: {
      height: '100%',
      border: '1px solid transparent',
      borderRadius: shorthandHelper([0, borderRadius.default, borderRadius.default, 0]),
      padding: shorthandHelper([0, spacing.default]),
    },
  }),

  tooltipBadge: css({
    marginLeft: spacing.small,
  }),

  tooltipContent: css({
    margin: 0,
    width: 200,
  }),

  formFieldset: css({
    marginBottom: spacing.large,

    '> legend': {
      fontWeight: fontWeight.medium,
      fontSize: fontSize.medium,
      marginBottom: spacing.medium,
    },
  }),

  heading: css({
    margin: shorthandHelper([spacing.default, 0, spacing.medium]),
    fontWeight: fontWeight.medium,
    color: colors.blackPearl,
  }),

  footer: css({
    marginTop: spacing.large,
  }),

  fullWidth: css({
    width: '100%',
  }),
}

export default styles
